// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stop_root_pUD1R {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  white-space: nowrap;
}

.stop_left_IKpmn {
  width: var(--left-width);
}

.stop_right_OtVzj {
  display: flex;
  padding-left: 10px;
  box-sizing: border-box;
  width: var(--right-width);
}

.stop_rightWide_qedTp {
  display: flex;
  padding-left: 10px;
  box-sizing: border-box;
  width: 233px;
}

.stop_title_VC19w {
  font-family: GothamRounded-Medium;
  font-size: 11px;
}

.stop_subtitle_A5sEy {
  font-family: GothamRounded-Book;
  font-size: 11px;
}

.stop_iconContainer_DsQON {
  display: flex;
  align-items: center;
  margin-left: 6px;
  margin-right: 6px;
}

.stop_routeContainer_Ys_BG {
  display: flex;
  justify-content: left;
  font-size: 0.5em;
  padding: 0 0.285em 0 0;
  font-family: GothamRounded-Book;
}

.stop_titleContainer_d1KzX {
  display: flex;
  align-items: center;
}

.stop_terminalAreaRoutesContainer_XmLCE {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.stop_compactRoutes_fmibh {
  max-width: 60px;
}

.stop_terminalAreaRoutesTitle_WfSP7 {
  font-size: 0.5em;
  white-space: initial;
  padding-bottom: 2px;
  font-family: GothamRounded-Medium;
}

.stop_icon_BxaBD {
  width: 20px;
  height: 20px;
  margin-left: 2px;
}

.stop_separator_pEDRL {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
}

.stop_separatorTop_nGGSx {
  height: 12px;
  border-left: var(--line-border);
}

.stop_separatorBottom_Bf_7q {
  height: 12px;
  border-left: var(--line-border);
}

.stop_separatorStop_bNUWQ {
  width: calc(4 * var(--line-width));
  height: calc(4 * var(--line-width));
  border: var(--line-border);
  border-radius: calc(4 * var(--line-width));
  margin-top: calc(var(--line-width) / -2);
  margin-bottom: calc(var(--line-width) / -2);
  margin-left: calc(-2.5 * var(--line-width));
}

.stop_separatorLastStop_qPFFO {
  background: var(--line-color);
  border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/routeDiagram/stop.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,0CAA0C;EAC1C,wCAAwC;EACxC,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EAEE,6BAA6B;EAC7B,gBAAgB;AAClB","sourcesContent":[".root {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  white-space: nowrap;\n}\n\n.left {\n  width: var(--left-width);\n}\n\n.right {\n  display: flex;\n  padding-left: 10px;\n  box-sizing: border-box;\n  width: var(--right-width);\n}\n\n.rightWide {\n  display: flex;\n  padding-left: 10px;\n  box-sizing: border-box;\n  width: 233px;\n}\n\n.title {\n  font-family: GothamRounded-Medium;\n  font-size: 11px;\n}\n\n.subtitle {\n  font-family: GothamRounded-Book;\n  font-size: 11px;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  margin-left: 6px;\n  margin-right: 6px;\n}\n\n.routeContainer {\n  display: flex;\n  justify-content: left;\n  font-size: 0.5em;\n  padding: 0 0.285em 0 0;\n  font-family: GothamRounded-Book;\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n}\n\n.terminalAreaRoutesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.compactRoutes {\n  max-width: 60px;\n}\n\n.terminalAreaRoutesTitle {\n  font-size: 0.5em;\n  white-space: initial;\n  padding-bottom: 2px;\n  font-family: GothamRounded-Medium;\n}\n\n.icon {\n  width: 20px;\n  height: 20px;\n  margin-left: 2px;\n}\n\n.separator {\n  display: flex;\n  flex-flow: column;\n  align-items: flex-start;\n}\n\n.separatorTop {\n  height: 12px;\n  border-left: var(--line-border);\n}\n\n.separatorBottom {\n  height: 12px;\n  border-left: var(--line-border);\n}\n\n.separatorStop {\n  width: calc(4 * var(--line-width));\n  height: calc(4 * var(--line-width));\n  border: var(--line-border);\n  border-radius: calc(4 * var(--line-width));\n  margin-top: calc(var(--line-width) / -2);\n  margin-bottom: calc(var(--line-width) / -2);\n  margin-left: calc(-2.5 * var(--line-width));\n}\n\n.separatorLastStop {\n  composes: separatorStop;\n  background: var(--line-color);\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `stop_root_pUD1R`,
	"left": `stop_left_IKpmn`,
	"right": `stop_right_OtVzj`,
	"rightWide": `stop_rightWide_qedTp`,
	"title": `stop_title_VC19w`,
	"subtitle": `stop_subtitle_A5sEy`,
	"iconContainer": `stop_iconContainer_DsQON`,
	"routeContainer": `stop_routeContainer_Ys_BG`,
	"titleContainer": `stop_titleContainer_d1KzX`,
	"terminalAreaRoutesContainer": `stop_terminalAreaRoutesContainer_XmLCE`,
	"compactRoutes": `stop_compactRoutes_fmibh`,
	"terminalAreaRoutesTitle": `stop_terminalAreaRoutesTitle_WfSP7`,
	"icon": `stop_icon_BxaBD`,
	"separator": `stop_separator_pEDRL`,
	"separatorTop": `stop_separatorTop_nGGSx`,
	"separatorBottom": `stop_separatorBottom_Bf_7q`,
	"separatorStop": `stop_separatorStop_bNUWQ`,
	"separatorLastStop": `stop_separatorLastStop_qPFFO stop_separatorStop_bNUWQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
